export enum ScheduledMessageStatuses {
  SCHEDULED = 'scheduled',
  CANCELED = 'canceled',
  ERROR = 'error',
  SENT = 'sent',
  NOT_SENT_CONVERSATION_FLOW = 'not_sent_conversation_flow',
}

export const translateScheduledMessageStatus = (
  status: ScheduledMessageStatuses,
) => {
  switch (status) {
    case ScheduledMessageStatuses.SCHEDULED:
      return 'En attente';

    case ScheduledMessageStatuses.CANCELED:
      return 'Annulé';

    case ScheduledMessageStatuses.SENT:
      return 'Envoyé';

    case ScheduledMessageStatuses.ERROR:
      return 'En erreur';

    case ScheduledMessageStatuses.NOT_SENT_CONVERSATION_FLOW:
      return 'Non envoyé (conversation en cours)';

    default:
      return 'Inconnu';
  }
};
